import { UIHeading3 } from '@cian/ui-kit';

import { type FC, type ReactNode, useMemo } from 'react';

import { prettyPluralize } from '@/packages/utils/prettyPluralize';

import styles from './HeaderSEOBlock.css';

type HeaderSEOBLockProps = {
  offersCount: number;
  title: ReactNode;
  sortButton: ReactNode;
  withFadeTitle?: boolean;
};

export const HeaderSEOBlock: FC<HeaderSEOBLockProps> = props => {
  const { title, offersCount, sortButton } = props;

  const text = useMemo(
    () => `Найдено ${prettyPluralize(offersCount, ['объявление', 'объявления', 'объявлений'])}`,
    [offersCount],
  );

  return (
    <div className={styles['header-container']}>
      <div className={styles['header-wrapper']}>{title}</div>
      <div className={styles['header-counter-wrapper']}>
        <UIHeading3 data-testid="listing.offers-count">{text}</UIHeading3>
        {sortButton}
      </div>
    </div>
  );
};
